// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LocalizedConfig } from 'shared_services/riseart/utils/LocalizedConfig';
import { EnquireArtworkFormModel } from 'shared_models/forms/EnquireArtwork';
import { WithEnquireSuccess } from 'shared_hocs/forms/WithEnquireSuccess';
import { TermsSection } from 'shared_components/forms/common/TermsSection';
import { AdvisorSection } from 'shared_components/forms/enquire/sections/Advisor';
import { DescriptionSection } from 'shared_components/forms/enquire/sections/Description';
import { CreateMailingListMutation } from 'shared_data/providers/queries/CreateMailingListMutation';
import { EnquireForm } from 'shared_hocs/forms/Enquire';
import { gtmArtworkEnquireOpen } from 'shared_data/providers/google/tagmanager/Actions';
import { artworkEnquireRequestSend } from 'shared_services/redux/actions/application/enquire';

import { enquireFormCls } from 'shared_components/forms/enquire/Form.less';

type Props = {
  artwork: Object,
  selectedFrame: Object,
  additionalInitialValues?: ?Object,
  formSettings?: Object,
  trigger: string,
  onClose: Function,
};

/**
 * EnquireArtworkForm
 */
export const EnquireArtworkForm = ({
  artwork,
  selectedFrame,
  additionalInitialValues = {},
  formSettings,
  trigger,
  onClose,
}: Props) => (
  <WithEnquireSuccess onClose={onClose}>
    {({ onSubmit }) => (
      <section className={enquireFormCls}>
        <FormattedMessage id="forms.emailEnquire.description">
          {(mainDescription: string) => (
            <DescriptionSection phone={LocalizedConfig.get('contact.advisor.phone')}>
              {mainDescription}
            </DescriptionSection>
          )}
        </FormattedMessage>
        <FormattedMessage id="forms.emailEnquire.send">
          {(actionLabel: string) => (
            <React.Fragment>
              <CreateMailingListMutation>
                {(createMailingList) => (
                  <EnquireForm
                    actionOpen={gtmArtworkEnquireOpen}
                    actionSubmit={artworkEnquireRequestSend}
                    onSubmit={onSubmit}
                    submitActionLabel={actionLabel}
                    additionalInitialValues={additionalInitialValues}
                    trackedData={{
                      artwork,
                      trigger,
                      ...(selectedFrame && selectedFrame.id ? { selectedFrame } : {}),
                    }}
                    formSettings={formSettings || EnquireArtworkFormModel}
                    createMailingList={createMailingList}
                  >
                    <AdvisorSection
                      name={LocalizedConfig.get('contact.advisor.name')}
                      avatar={LocalizedConfig.get('contact.advisor.avatar')}
                    />
                  </EnquireForm>
                )}
              </CreateMailingListMutation>
              <TermsSection translationValues={{ actionLabel }} />
            </React.Fragment>
          )}
        </FormattedMessage>
      </section>
    )}
  </WithEnquireSuccess>
);
